/**
 * @generated SignedSource<<3f9652974c7568530b7610a5d424a908>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountEditAccountOwnerCard_employee$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "AccountEditAccountOwnerCard_employee";
};
export type AccountEditAccountOwnerCard_employee$key = {
  readonly " $data"?: AccountEditAccountOwnerCard_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountEditAccountOwnerCard_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountEditAccountOwnerCard_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "d4d6ab8f69eeacc51ec6aeccce2d5636";

export default node;
